export default __webpack_public_path__ + "static/media/verified_Grey.de21fc63.svg";